(function() {
	'use strict';

	angular
		.module('iqxCore')
		.controller('JobSearchSimpleCtrl', JobSearchSimpleCtrl)


	function JobSearchSimpleCtrl($scope, $location, SweetAlert, JobSearchSvc) {

		if ($scope.userHasRight('CANDHIDEJOBSPAGE')) {
			$location.url('/noPermission')
			return
		}
	
		$scope.SearchValue=JobSearchSvc.LastSearchTextValue || ''  // Retrieve last used value if any
		
		JobSearchSvc.getSearchFields()
	
		$scope.search=function(){
			var val=$scope.SearchValue
			if (val===undefined || val=='' || val.length<3) {
				SweetAlert.swal("Error", "You need at least 3 alphanumeric characters to search.", "error")
			} else {
				JobSearchSvc.LastSearchTextValue=val  // Save for next use (independently from full criteria search)
				JobSearchSvc.searchInit()  // Force a new search (as opposed to using existing results)
				JobSearchSvc.searchValues={$text:val}
				$location.url('/jobsearch/results')  // Go to the job search results page
			}
		}
	}

})()